import { Component, OnInit, Input } from '@angular/core';
import { SharedProgrammingService } from '../services/shared-programming.service';

@Component({
  selector: 'prg-protected-programming,[prg-protected-programming]',
  templateUrl: './protected-programming.component.html',
  styleUrls: ['./protected-programming.component.less']
})
export class ProtectedProgrammingComponent implements OnInit {

  @Input() codeitem: any;
  @Input() editing: boolean;

  expanded: boolean;

  constructor() {
    this.expanded = false;
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/protected-programming/protected-programming.component.ts